import { useEffect, useState } from 'react';

// Task 3.3 — shared source of truth for the OS-level "reduce motion" preference.
// The motion utilities in src/motion.jsx use this to render content in its final
// state immediately (no transform/fade) for users who asked for reduced motion,
// rather than showing a diminished version of the same animation. A global CSS
// guard in src/index.css handles CSS transitions/animations (hover states, the
// ambient background); this hook handles the JS-driven framer-motion reveals.
const QUERY = '(prefers-reduced-motion: reduce)';

function getInitialState() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia(QUERY).matches;
}

export default function usePrefersReducedMotion() {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(getInitialState);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }
    const mediaQuery = window.matchMedia(QUERY);
    const onChange = () => setPrefersReducedMotion(mediaQuery.matches);
    onChange();
    // addEventListener is the modern API; addListener is the Safari <14 fallback.
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', onChange);
      return () => mediaQuery.removeEventListener('change', onChange);
    }
    mediaQuery.addListener(onChange);
    return () => mediaQuery.removeListener(onChange);
  }, []);

  return prefersReducedMotion;
}
